import { useCallback, useEffect, useMemo, useRef } from 'react';
import { notification } from 'antd';
import GYAxios from '../../util/GYAxios';
import { useUser } from '../../util/user';

const NoticePopup = () => {
  const user = useUser();
  const shownNoticeRef = useRef(false);
  const shownIdsRef = useRef(new Set());

  const isUserLoggedIn = useCallback(() => {
    return Boolean(user && (user.sub || user.id || user.user_id));
  }, [user]);

  const isUserNotLoggedIn = useCallback(() => {
    return !isUserLoggedIn();
  }, [isUserLoggedIn]);

  const visibilityFn = useMemo(() => ({ "isUserLoggedIn": isUserLoggedIn, "isUserNotLoggedIn": isUserNotLoggedIn }), [isUserLoggedIn, isUserNotLoggedIn]);

  useEffect(() => {
    const fetchNotices = async () => {
      if (shownNoticeRef.current) return;
      try {
        const res = await GYAxios.get('/alarms/notice_popup_messages/current-active');

        shownNoticeRef.current = true;
        if (!res.data.success) return;

        const messages = res.data.data;
        if (!Array.isArray(messages) || messages.length === 0) return;

        messages.forEach((msg) => {
          const id = msg.id ?? JSON.stringify(msg);
          if (shownIdsRef.current.has(id)) return;

          const hasVisibilityFn = typeof msg.visibilityFn === 'string' && msg.visibilityFn.trim();
          const shouldDisplay = !hasVisibilityFn
            || !Object.prototype.hasOwnProperty.call(visibilityFn, msg.visibilityFn)
            || visibilityFn[msg.visibilityFn]();

          if (!shouldDisplay) return;

          shownIdsRef.current.add(id);

          notification.open({
            key: `notice_${id}`,
            message: msg.title || 'Notice',
            description: msg.message || '',
            placement: 'bottomRight',
            duration: 0, // stay open until user closes
            onClose: () => {
              // keep record of shown messages so they don't reappear automatically
            },
          });
        });
      } catch (e) {
        // fail silently
      }
    };

    const timeout = setTimeout(() => {
      fetchNotices();
    }, 5000);
    return () => clearTimeout(timeout);

  }, [user, visibilityFn]);

  return null;
};

export default NoticePopup;